import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-orders-reports-nb-sales-card',
  templateUrl: './orders-reports-nb-sales-card.component.html',
  styleUrls: ['./orders-reports-nb-sales-card.component.scss']
})
export class OrdersReportsNbSalesCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
